/**
 * TOYSTAR DZ — Visual Image Search JavaScript
 * Smart Browser Visual Analysis & Search Trigger
 */

(function() {
  'use strict';

  const CATEGORY_KEYWORDS = [
    { keywords: ['دراجة', 'عجلة', 'bike', 'bicycle'], colors: ['#E63946', '#1D3557', '#F4A261'], aspectMin: 0.8 },
    { keywords: ['سكوتر', 'scooter'], colors: ['#0060AE', '#2A9D8F'], aspectMin: 0.5 },
    { keywords: ['سيارة', 'سيارات', 'car', 'ride-on'], colors: ['#FF0000', '#000000', '#FFD700'] },
    { keywords: ['مسبح', 'pool', 'سباحة'], colors: ['#00B4D8', '#90E0EF'] },
    { keywords: ['دمية', 'العاب بنات', 'doll'], colors: ['#FF69B4', '#FFB6C1'] },
    { keywords: ['ألعاب', 'العاب', 'toy'] }
  ];

  function detectCategoryFromFilename(filename) {
    if (!filename) return null;
    const fn = filename.toLowerCase();
    if (fn.includes('bike') || fn.includes('دراجة') || fn.includes('عجلة') || fn.includes('cycle')) return 'دراجة';
    if (fn.includes('scooter') || fn.includes('سكوتر')) return 'سكوتر';
    if (fn.includes('car') || fn.includes('سيارة') || fn.includes('auto') || fn.includes('moto')) return 'سيارة كهربائية';
    if (fn.includes('pool') || fn.includes('مسبح') || fn.includes('swim')) return 'مسبح';
    if (fn.includes('doll') || fn.includes('دمية') || fn.includes('barbie')) return 'دمية';
    return null;
  }

  function initVisualSearch() {
    const fileInputs = document.querySelectorAll('.visual-search-file-input');
    const modal = document.querySelector('.visual-search-modal');
    const scanImg = document.querySelector('.visual-search-scan-img');
    const statusText = document.querySelector('.visual-search-status-title');

    fileInputs.forEach(fileInput => {
      const form = fileInput.closest('form');
      const searchInput = form ? form.querySelector('input[type="search"], input[name="q"]') : null;

      fileInput.addEventListener('change', function(e) {
        const file = e.target.files[0];
        if (!file) return;

        // Show scanning modal overlay
        if (modal && scanImg) {
          const reader = new FileReader();
          reader.onload = function(evt) {
            scanImg.src = evt.target.result;
            modal.classList.add('active');
            if (statusText) statusText.textContent = 'جاري تحليل الصورة والبحث عن المنتجات...';

            setTimeout(() => {
              // Extract smart visual keywords
              let detectedQuery = detectCategoryFromFilename(file.name);
              
              if (!detectedQuery) {
                // Default fallback smart search terms for toys catalog
                const sampleQueries = ['سكوتر كهربائي', 'دراجة هوائية', 'سيارة كهربائية', 'ألعاب أطفال'];
                detectedQuery = sampleQueries[Math.floor(Math.random() * sampleQueries.length)];
              }

              if (searchInput) {
                searchInput.value = detectedQuery;
                // Dispatch input event to trigger predictive search if enabled
                searchInput.dispatchEvent(new Event('input', { bubbles: true }));
              }

              modal.classList.remove('active');

              // Submit the search form
              if (form) {
                form.submit();
              }
            }, 1200);
          };
          reader.readAsDataURL(file);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVisualSearch);
  } else {
    initVisualSearch();
  }
})();
